import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ParameterType } from '../../types/parameterType';
import { api } from '../../services/api';

interface ParameterTypeState {
  items: ParameterType[];
  loading: boolean;
  error: string | null;
}

const initialState: ParameterTypeState = {
  items: [],
  loading: false,
  error: null,
};

export const fetchParameterTypes = createAsyncThunk('parameterTypes/fetchAll', async () => {
  const response = await api.get('/parameter-types');
  return response.data;
});

export const parameterTypeSlice = createSlice({
  name: 'parameterTypes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchParameterTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchParameterTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchParameterTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch parameter types';
      });
  },
});

export default parameterTypeSlice.reducer;
